<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <div class="md-layout vm-top-login md-gutter md-alignment-center-center">
        <md-card class="md-layout-item md-size-40 md-medium-size-60 md-small-size-100">
          <md-card-header>
            <div class="text-center">
              <img
                :src="require('../../assets/img/logo-Viewmed.svg')"
                alt="$t('title.viewmed')"
                class="vm-logo my-3"
              />
              <h3 class="mt-3">{{ $t('title.new_password') }}</h3>
              <md-divider class="vm-divider-green vm-line-w-login"></md-divider>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout md-gutter md-alignment-center-center">
              <div class="md-layout-item md-size-80 md-small-size-90">
                <md-field :class="getValidationClass('passwd')">
                  <md-icon>lock</md-icon>
                  <label>{{$t('title.insert_new_password')}}</label>
                  <md-input id="passwd" type="text" v-model="form.passwd"></md-input>
                  <span
                    class="md-error"
                    v-if="!$v.form.passwd.required"
                  >{{ $t('title.insert_new_password') }}</span>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter md-alignment-center-center">
              <div class="md-layout-item md-size-80 md-small-size-90">
                <md-field :class="getValidationClass('confirmPassw')">
                  <md-icon>lock</md-icon>
                  <label>{{$t('title.confirm_password')}}</label>
                  <md-input id="confirmPassw" type="text" v-model="form.confirm"></md-input>
                  <span
                    class="md-error"
                    v-if="!$v.form.confirm.samePassw"
                  >{{$t('title.confirm_password')}}</span>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter text-center">
              <div class="md-layout-item md-small-size-100" v-if="!displayed_spinner">
                <md-button
                  type="submit"
                  class="md-dense md-raised vm-bg-patient"
                >{{ $t('title.save') }}</md-button>
              </div>
            </div>
            <div class="text-center" v-if="displayed_spinner">
              <md-progress-spinner md-mode="indeterminate" :md-diameter="30" :md-stroke="3"></md-progress-spinner>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </form>
  </div>
</template>
<script>
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { updatePassword, decodeRegister } from "../home/homeServ";

import { Base64 } from "js-base64";

export default {
  name: "recoverPassword",
  data() {
    return {
      form: {
        passwd: null,
        confirm: null
      },
      objAux: {
        id: null,
        email: null,
        token: null,
        passwd: null
      },
      displayed_spinner: false
    };
  },
  validations: {
    form: {
      passwd: {
        required,
        minLength: minLength(6)
      },
      confirm: {
        minLength: minLength(6),
        samePassw: sameAs("passwd")
      }
    }
  },
  created() {},
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    validateUser() {
      this.displayed_spinner = true;
      this.objAux = {
        id: sessionStorage.getItem("id"),
        email: sessionStorage.getItem("email"),
        token: sessionStorage.getItem("token"),
        passwd: Base64.encode(this.form.passwd)
      };
      updatePassword(this.objAux).then(result => {
        this.displayed_spinner = false;
        this.$store.state.active = false;
        this.$store.commit("showDialog");
        this.$router.push("/");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/recoverPassword.vue